import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection({ restaurantId, restaurantName, heroImageUrl, statusBanner }) {
  const { t } = useTranslation();

  return (
    <header className="ri-hero" aria-label={restaurantName}>
      <div className="ri-hero-bg">
        {heroImageUrl ? (
          <img src={heroImageUrl} alt="" className="ri-hero-img" loading="eager" />
        ) : (
          <div className="ri-hero-gradient" aria-hidden="true" />
        )}
        <div className="ri-hero-overlay" aria-hidden="true" />
      </div>
      <div className="ri-hero-content">
        <Link to={`/menu/${restaurantId}`} className="ri-hero-back" aria-label={t('restaurant.info.backToMenu')}>
          <span className="ri-hero-back-arrow" aria-hidden="true">←</span>
          <span>{t('restaurant.info.backToMenu')}</span>
        </Link>
        <div className="ri-hero-glass">
          <h1 className="ri-hero-title">{restaurantName || 'Restaurant'}</h1>
          {statusBanner && (
            <div className={`ri-hero-status ri-hero-status--${statusBanner.status}`} role="status">
              {statusBanner.status === 'open' && (
                <span>✓ {t('restaurant.info.statusOpen', 'Open Now')}{statusBanner.closesAt ? ` • ${t('restaurant.info.closesAt', 'Closes')} ${statusBanner.closesAt}` : ''}</span>
              )}
              {statusBanner.status === 'closed' && (
                <span>{t('restaurant.info.statusClosed', 'Closed')}{statusBanner.nextOpen ? ` • ${t('restaurant.info.opensAt', 'Opens')} ${statusBanner.nextOpen}` : ''}</span>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
